import { getSubscreen } from '../NotificationsUsageTrackers';
export const sidebarNotificationInteractionFactory = ({
  deliveryMethod,
  originName,
  templateId,
  typeId
}, {
  ctaProxyUrl,
  id
}) => {
  return {
    delivery_method: deliveryMethod,
    notification_origin: originName,
    notification_template_id: templateId,
    notification_type: typeId,
    link: ctaProxyUrl,
    notificationId: id,
    subscreen: getSubscreen()
  };
};